<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop py-5">
      <div class="wrapper">
        <div class="card mx-auto pb-3">
          <div class="d-flex justify-content-end pt-3 pr-2 p-lg-2">
            <img
              src="@/assets/icon/close.png"
              alt="close"
              class="pointer"
              @click="$emit('close', 'edit')"
            >
          </div>
          <div class="text-center">
            <h5 class="font-weight-bold">
              {{ $t('manage-master-data.company.head-update') }}
            </h5>
          </div>
          <div
            v-if="isLoadingGet"
            class="text-center mt-5"
          >
            <div class="spinner-border spinner-border-sm">
              <span class="sr-only">
                Loading...
              </span>
            </div>
          </div>
          <div v-else>
            <div class="row m-0 px-3 py-1">
              <div class="col-sm-6 pb-1 pb-sm-0">
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.company.label.company') }}
                </small>
                <input
                  v-model="form.name"
                  :class="{'border border-danger': $v.form.name.$error}"
                  type="text"
                  class="form-control form-control-sm"
                >
                <div
                  v-if="!$v.form.required && $v.form.name.$error"
                  class="text-danger"
                >
                  <small>
                    {{ $t('manage-master-data.company.form-error.company-required') }}
                  </small>
                </div>
              </div>
              <div class="col-sm-6 pb-1 pb-sm-0">
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.company.label.code') }}
                </small>
                <input
                  v-model="form.code"
                  type="text"
                  class="form-control form-control-sm"
                >
              </div>
            </div>
            <div class="row m-0 px-3 py-1">
              <div class="col-12">
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.company.label.contractor') }}
                </small>
                <v-select
                  v-model="form.contractors"
                  class="sm"
                  label="name"
                  multiple
                  :reduce="getReduceId"
                  :options="dataApi.contractors"
                />
              </div>
            </div>
            <div class="row m-0 px-3 py-1">
              <div class="col-12">
                <small class="font-weight-bold">
                  {{ $t('manage-master-data.company.label.work-location') }}
                </small>
                <v-select
                  v-model="form.workLocations"
                  class="sm"
                  label="name"
                  multiple
                  :reduce="getReduceId"
                  :options="dataApi.workLocations"
                />
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <button
                v-if="permission.permissions.includes('delete')"
                class="btn btn-danger col-6 col-sm-2 mx-2"
                @click="showModal('delete')"
              >
                {{ $t('manage-master-data.delete') }}
              </button>
              <button
                v-if="!isLoadingSubmit"
                class="btn btn-info col-6 col-sm-2 mx-2"
                @click="submit"
              >
                {{ $t('manage-master-data.save') }}
              </button>
              <button
                v-else
                class="btn btn-info col-6 col-sm-2 mx-2"
              >
                <div class="spinner-border spinner-border-sm">
                  <span class="sr-only">
                    Loading...
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalSuccess
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <modal-delete-company
      v-if="modal.delete"
      class="in-front-of"
      :id-company="id"
      :name-company="form.name"
      @close="closeModal"
    />
  </portal>
</template>

<script>
import VSelect from 'vue-select'
import Api from '@/utils/Api'
import { required } from 'vuelidate/lib/validators'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalDeleteCompany from './ModalDeleteCompany'

export default {
  components: {
    VSelect,
    ModalSuccess,
    ModalUnsuccessful,
    ModalDeleteCompany
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    permission: {
      type: Object,
      default: () => ({
        permissions: []
      })
    }
  },

  data: () => ({
    dataApi: {
      contractors: [],
      workLocations: []
    },
    form: {
      name: '',
      code: '',
      contractors: [],
      workLocations: []
    },
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false,
      delete: false
    },
    isLoadingSubmit: false,
    isLoadingGet: false
  }),

  async created () {
    this.isLoadingGet = true
    await this.getContractors()
    await this.getWorkLocations()
    await this.initial()
    this.isLoadingGet = false
  },

  methods: {
    getReduceId: ({ id }) => id,
    async getContractors () {
      const { data } = await Api.contractors.list()
      this.dataApi.contractors = data.data
      this.dataApi.contractors.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    async getWorkLocations () {
      const { data } = await Api.workLocations.list()
      this.dataApi.workLocations = data
      this.dataApi.workLocations.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    async initial () {
      const { data } = await Api.companies.get(this.id)
      this.form.code = data.code
      this.form.name = data.name
      this.form.contractors = data.contractors.map(element => element.id)
      this.form.workLocations = data.workLocations.map(element => {
        const found = this.dataApi.workLocations.findIndex(elementWork => elementWork.id === element.id)
        if (found !== -1) {
          return element.id
        }
      })
      this.form.workLocations = this.form.workLocations.filter(element => element !== undefined)
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname, isOpenEdit) {
      this.modal[modalname] = false
      if (!isOpenEdit) {
        this.$emit('close', 'edit')
      }
    },
    async submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoadingSubmit = true
        const formUpdate = {
          name: this.form.name
        }
        if (this.form.code) {
          formUpdate.code = this.form.code
        }
        if (this.form.workLocations.length) {
          formUpdate.workLocations = this.form.workLocations
        }
        if (this.form.contractors.length) {
          formUpdate.contractors = this.form.contractors
        }
        const data = await Api.companies.update(this.id, formUpdate)
        this.isLoadingSubmit = false
        if (data.status === 200) {
          this.modal.textModal = this.$t('manage-master-data.company.success-update', { name: this.form.name })
          this.showModal('success')
        } else {
          this.modal.textModal = this.$i18n.locale === 'en' ? data.data.message.messageEng : data.data.message.messageIdn
          this.showModal('unsuccessful')
        }
      }
    }
  },

  validations: {
    form: {
      name: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  display: flex;
  padding-left: 0;
  z-index: 10;
}
.card {
  margin: 0 auto;
  width: 800px;
  border-radius: 18px;
}
.card-body {
  height: 400px;
}
.pointer {
  cursor: pointer;
}
.in-front-of {
  z-index: 10000;
}

::v-deep(.vs__dropdown-toggle) {
  background: white;
}

::v-deep(.vs__selected-options) {
  flex-wrap: nowrap;

  .vs--open & {
    flex-wrap: wrap;
    max-height: 100px;
    overflow: scroll;
  }
}

::v-deep(.vs__dropdown-menu) {
  height: 250px;
}
</style>
